import $ from 'jquery';

let cache = null;

/** Reads nav data from script tag in the dom
 *
 * @returns {Object} Nav data in format { title: string, elements: { name: string, url?: string, child: Array<NavData> } }
 */
export function getNavData () {
    if (cache) return cache;

    function addElement(li, parent) {
        const $a = li.children('a').first();
        const nel = {
            name: $a.text().trim(),
            huge: $a.hasClass('huge')
        };

        if ($a.attr('href')) nel.url = $a.attr('href');

        const child = {
            title: nel.name,
            elements: [],
            parent: parent,
        };

        li.children('ul').first().children('li').each(function () {
            addElement($(this), child);
        });

        if (child.elements.length > 0) nel.child = Object.freeze(child);

        parent.elements.push(Object.freeze(nel));
    }

    const navObject = {
        parent: null,
        title: "",
        elements: []
    };

    const nav = $('#nav');
    nav.children('ul').first().children('li').each(function () {
       addElement($(this), navObject);
    });
    nav.remove();

    cache = Object.freeze(navObject);


    return cache;
}
